module.exports = __webpack_public_path__ + "static/media/phone-icon-navbar-black.a26b1a24.svg";